import { render, staticRenderFns } from "./PickupCard.vue?vue&type=template&id=034d7bef&scoped=true&"
import script from "./PickupCard.vue?vue&type=script&lang=js&"
export * from "./PickupCard.vue?vue&type=script&lang=js&"
import style0 from "./PickupCard.vue?vue&type=style&index=0&id=034d7bef&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034d7bef",
  null
  
)

export default component.exports